// extracted by mini-css-extract-plugin
export default {"message":"SeRGqWU7WPUilwiSiEDQ","description":"vc1zI4lo7g8lOptirL5Q","link":"nLLxMiuNswgzySxx7_hQ"};